export default {
    receiptLabel: 'Receipt',
    transactionDate: 'Transaction Date & Time: ',
    invoice: 'Invoice',
    incomeAccountName: 'Merchant Name',
    cardNumber: 'Card No.',
    promptPay: 'Method',
    backToHome: 'Back to Home',
    receipt: 'Receipt',
    failLabel: 'Payment Failed',
    plsTryAgain: 'Your transaction couldn’t be completed at this time.',
    checkCardInfo: 'Please double-check your payment method or try another one.',
    total: 'Net Amount',
    coution: 'Refer to card issuer',
    tryAgain: 'Try Again'
}
